/** The part of `Storage` the cleanup needs. */
export interface IGpthelpStorage {
  readonly length: number;
  key(index: number): string | null;
  removeItem(key: string): void;
}

/** The widget's own keys (conversations, sessions) start with this. */
const WIDGET_KEY_PREFIX = 'gpthelp-';

/** This chatbot's widget keys in `storage`. */
export function gpthelpStorageKeys(
  storage: IGpthelpStorage,
  chatbotId: string
): string[] {
  const keys: string[] = [];
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (key && key.startsWith(WIDGET_KEY_PREFIX) && key.includes(chatbotId))
      keys.push(key);
  }
  return keys;
}

/**
 * Removes this chatbot's widget keys from `storage` (plan §9.11), so the
 * next user of a shared device never resumes the previous user's chats.
 * The admin's own `gpthelp.*` overrides are kept.
 */
export function clearGpthelpStorage(
  chatbotId: string,
  storage?: IGpthelpStorage
): void {
  try {
    const target = storage ?? window.localStorage;
    // Collected first: removing while iterating shifts the indexes.
    gpthelpStorageKeys(target, chatbotId).forEach((key) =>
      target.removeItem(key)
    );
  } catch (error) {
    console.warn('[assistant] Could not clear the GPTHelp storage', error);
  }
}
